// React Imports
import { ReactElement } from "react";

// Third Party Imports
import { Link } from "react-router-dom";
import { Breadcrumb } from "antd";
import { useSelector } from "react-redux";

// Style Imports
import "./breadcrumb-component.scss";

const BreadcrumbComponent: React.FC = (): ReactElement => {
  const breadcrumb = useSelector((state: any) => state.breadcrumb)?.map((item: any) => {
    
    if (item?.type === 'link') {
      return {
        title: <Link to={item.link}>{item.text}</Link>
      }
    } else {
      return {
        title: item.text
      }
    }
  });
  

  return (
    <Breadcrumb
      items={breadcrumb}
      className=" mb-3"
    />
  );
};

export default BreadcrumbComponent;
